module.exports = __webpack_public_path__ + "img/banner3.0cad9cc8.jpg";